import { render, staticRenderFns } from "./recover.vue?vue&type=template&id=10db4e8d&"
import script from "./recover.vue?vue&type=script&lang=js&"
export * from "./recover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports